import { IntlShape } from 'react-intl';

import { recipeMessages } from '@data/ui-messages/recipes';
import { CmsRecipeDifficulty } from '@interfaces/common';

import { durationFromMinutes } from './date';
import { neverError } from './neverError';

export const intlRecipeDifficulty = (
	intl: IntlShape,
	difficulty: CmsRecipeDifficulty
) => {
	switch (difficulty) {
		case 'Easy':
			return intl.formatMessage(recipeMessages.easy);

		case 'Medium':
			return intl.formatMessage(recipeMessages.medium);

		case 'Hard':
			return intl.formatMessage(recipeMessages.hard);

		case undefined:
			// Newly added section types come back as undefined
			// We don’t want to display an error in this case
			return null;

		default: {
			throw neverError('Unknown section type', difficulty);
		}
	}
};

export const intlRecipeDuration = (intl: IntlShape, minutes: number) => {
	return durationFromMinutes(minutes, {
		minutes: intl.formatMessage(recipeMessages.abbreviatedMins),
		hours: intl.formatMessage(recipeMessages.abbreviatedHours),
	});
};
